import CategoryEnum from "../enums/categoryEnum";
import SnackbarTypeEnum from "../enums/sanckbarTypeEnum";
import moment from "moment/moment";
import DateFormatEnum from "../enums/dateFormatEnum";
require('moment/locale/el');

moment.updateLocale('el', {
  eras: [
    {
      since: '0001-01-01',
      until: +Infinity,
      offset: 1,
      name: 'μετά Χριστόν',
      narrow: 'μ.Χ.',
      abbr: 'μ.Χ.'
    },
    {
      until: -Infinity,
      since: '0000-12-31',
      offset: 1,
      name: 'προ Χριστού',
      narrow: 'π.Χ.',
      abbr: 'π.Χ.'
    }
  ],
  months: [
    "Ιαν", "Φεβ", "Μαρ", "Απρ", "Μαϊ", "Ιουν", "Ιουλ", "Αυγ", "Σεπ", "Οκτ", "Νοε", "Δεκ"
  ]
});

class GenericHelper {
  getCategoryElNameByEnum(categoryEnum) {
    switch (categoryEnum) {
      case CategoryEnum.event:
        return 'Γεγονός';
      case CategoryEnum.exhibit:
        return 'Έκθεμα';
      default:
        return '';
    }
  }

  getCategoryEnNameByEnum(categoryEnum) {
    switch (categoryEnum) {
      case CategoryEnum.event:
        return 'Event';
      case CategoryEnum.exhibit:
        return 'Exhibit';
      default:
        return '';
    }
  }

  copyToClipboard(text) {
    const textField = document.createElement('textarea');
    textField.innerText = text;
    document.body.appendChild(textField);
    textField.select();
    textField.setSelectionRange(0, 99999)
    navigator.clipboard.writeText(textField.value);
    textField.remove();
  };

  createColor(color, opacity) {
    return color
  }

  getAllAvailableCategories() {
    return [CategoryEnum.event, CategoryEnum.exhibit]
  }

  getCategoryColorByEnum(categoryEnum) {
    switch (categoryEnum) {
      case CategoryEnum.event:
        return '#ff7c44';
      case CategoryEnum.exhibit:
        return '#00a99c';
      default:
        return 'black';
    }
  }

  getCategoryColorByGrName(categoryName) {
    switch (categoryName) {
      case 'Γεγονός':
        return '#ff7c44';
      case 'Έκθεμα':
        return '#00a99c';
      default:
        return 'black';
    }
  }

  wordCounter(str, min, max) {
    str = str.replace(/(^\s*)|(\s*$)/gi, "");
    str = str.replace(/[ ]{2,}/gi, " ");
    str = str.replace(/\n /, "\n");

    const count = str.split(' ').length;
    return count >= min && count <= max;
  }

  getTextWithMaxLength(text, maxLength) {
    if (maxLength !== 0 && text.length > maxLength) {
      const limit = text.substr(0, maxLength).lastIndexOf(' ');
      return text.substr(0, limit) + ' ...';
    }
    return text;
  }

  desc(a, b, order, orderBy) {
    if (orderBy === 'startYear') {
      if (b[orderBy] < a[orderBy]) {
        return -1;
      }
      if (b[orderBy] > a[orderBy]) {
        return 1;
      }
      return 0;
    }
    if (orderBy === 'period.title.el') {
      if (b.period?.title?.el < a.period?.title?.el) {
        return -1;
      }
      if (b.period?.title?.el > a.period?.title?.el) {
        return 1;
      }
      return 0;
    } else if (orderBy === 'category') {
      if (b[orderBy] < a[orderBy]) {
        return -1;
      }
      if (b[orderBy] > a[orderBy]) {
        return 1;
      }
      if (b[orderBy] === a[orderBy]) {
        if (order === 'desc') {
          return -this.desc(a, b, order, 'startYear');
        }
        return this.desc(a, b, order, 'startYear');
      }
      return 0;
    } else {
      if (b[orderBy]?.el < a[orderBy]?.el) {
        return -1;
      }
      if (b[orderBy]?.el > a[orderBy]?.el) {
        return 1;
      }
      return 0;
    }
  }

  stableSort(array, cmp) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = cmp(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
  }

  getSorting(order, orderBy) {
    return order === 'desc' ? (a, b) => this.desc(a, b, order, orderBy) : (a, b) => -this.desc(a, b, order, orderBy);
  }

  getYear(start, end) {
    if (start < -6000) {
      return '';
    }

    let textToReturn = '';

    if (start) {
      if (start < 0) {
        textToReturn = (-1 * start) + ' π.Χ.';
      } else {
        textToReturn = start + ' μ.Χ.';
      }
    }

    if (end) {
      if (end < 0) {
        textToReturn += ' - ' + (-1 * end) + ' π.Χ.';
      } else {
        textToReturn += ' - ' + end + ' μ.Χ.';
      }
    }

    return textToReturn;
  };

  getItemYear(dateString) {
    if (!dateString) {
      return null;
    }
    const date = moment.utc(dateString);

    return date.year();
  };

  getYearFromDateString(dateString) {
    return this.getItemYear(dateString);
  };

  getGreekDateString(startDateString, endDateString, lang='el') {
    if (!startDateString) {
      return '';
    }

    const startDate = moment.utc(startDateString);

    if (startDate.year() < -6000) {
      return '';
    }

    let textToReturn = startDate.locale(lang).format('DD/MM/y N');

    if (endDateString) {
      const endDate = moment.utc(endDateString);
      textToReturn += ' - ' + endDate.locale(lang).format('DD/MM/y N');
    }

    return textToReturn;
  };

  getGreekItemDateString(item, lang='el') {
    const startDateString = item.startDate;

    if (!startDateString) {
      return '';
    }

    const startDate = moment.utc(startDateString);

    if (startDate.year() < -6000) {
      return '';
    }
    const endDateString = item.endDate;
    const startDateFormat = this.getDateFormatFromDateFormatEnum(item.startDateFormat);
    const endDateFormat = this.getDateFormatFromDateFormatEnum(item.endDateFormat);

    let textToReturn = startDate.locale(lang).format(startDateFormat + ' N');

    if (endDateString) {
      const endDate = moment.utc(endDateString);
      textToReturn += ' - ' + endDate.locale(lang).format(endDateFormat + ' N');
    }

    return textToReturn;
  };

  getDateFromDateString(dateString) {
    if (!dateString) {
      return null;
    }

    return moment.utc(dateString).toDate();
  };

  getMonthNameFromDate(date, locale) {
    return moment(date).locale(locale).format('MMM');
  }

  getYearFromDate(date, locale) {
    return moment(date).locale(locale).format('y N');
  }

  getDateFormatFromDateFormatEnum(dateFormatEnum) {
    switch (dateFormatEnum) {
      case DateFormatEnum.date.toString():
        return 'DD/MM/y';
      case DateFormatEnum.monthYear.toString():
        return 'MMM y';
      case DateFormatEnum.year.toString():
        return 'y';
      default:
        return 'DD/MM/y';
    }
  };

  getSnackbarBackgroundColor(snackbarType) {
    switch (snackbarType) {
      case SnackbarTypeEnum.SUCCESS:
        return '#4caf50';
      case SnackbarTypeEnum.ERROR:
        return '#f44336';
      case SnackbarTypeEnum.WARNING:
        return '#ff9800';
      default:
        return 'black';
    }
  }
}


export const genericHelper = new GenericHelper();
